import { trigger, state, transition, style, animate, query } from '@angular/animations';

export const hiddenCollapseAnimation =
    trigger(
        'isHidden',
        [
            state('true', style({ height: 0, opacity: 0, display: 'none' })), // hidden
            state('false', style({ height: '*', opacity: 1, display: 'inherit' })),
            transition('1 => 0',

                query('*',
                    animate(500,
                        style({
                            height: '*', opacity: 1, display: 'inherit'
                        })
                    )
                )
            ), // visible
            transition('0 => 1',
                query('*',
                    animate(500, style({ height: 0, opacity: 0, display: 'none' }))
                )
            ) // hidden
        ]

    );



// WEBPACK FOOTER //
// ./src/app/shared/animations/hidden-collapse-animation.ts